import BaseProxy from './Proxy';

export default class SubstoreSubscriptionCancelProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/subscriptionCancel', parameters);
  }
}
